import axios from 'axios';
import { API_CONFIGS, AXIOS_CONFIG } from '../configs';
import { ACTIONS } from './index';

export function fetchInitData() {
  const axiosInstance = axios.create(AXIOS_CONFIG());
  const request = axiosInstance.get( API_CONFIGS.INIT_DATA );

  return {
    type: ACTIONS.INIT_DATA,
    payload: request,
  }
}
